// `uiFenceDocumentBlocks`, loaded with the document screens' code instead of
// the app's first file: `documentsScreen({ blocks: loadUiFenceDocumentBlocks })`.
import type { DocumentBlockPart } from "../documents/blocks/block-parts";

export const loadUiFenceDocumentBlocks = (): Promise<
  readonly DocumentBlockPart[]
> => import("./document-part").then((m) => [m.uiFenceDocumentBlocks]);
